export const checkValueOrArray = (
  primitive: string,
  arrayOrPrimitive: string | string[]
): boolean => {
  if (Array.isArray(arrayOrPrimitive)) {
    const values = new Set(arrayOrPrimitive);
    return values.has(primitive);
  }
  return primitive === arrayOrPrimitive;
};
